export function ehDataValida(data: string) {
  const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const match = data.match(regex);

  if (!match) return false;

  const dia = parseInt(match[1], 10);
  const mes = parseInt(match[2], 10);
  const ano = parseInt(match[3], 10);

  const dateObj = new Date(ano, mes - 1, dia);

  return (
    dateObj.getFullYear() === ano &&
    dateObj.getMonth() === mes - 1 &&
    dateObj.getDate() === dia
  );
}
